(function(){
    'use strict'

    angular
    .module('app.archivoCCSS')
    .controller('GrandesContribuyentes', GrandesContribuyentes);

    GrandesContribuyentes.$inject = ['$q', '$animationsSrv', 'ArchivoCCSSService', 'logger', '$location', 'TiposPlanillaService', 'PuestosService', 'DepartamentosService', 'ReportesService', 'UserInfoService', 'CoreSrv', 'moment'];

    function GrandesContribuyentes($q, $animationsSrv, ArchivoCCSSService, logger, $location, TiposPlanillaService, PuestosService, DepartamentosService, ReportesService, UserInfoService, CoreSrv, moment) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        var searchKey = "Grandes_Contribuyentes_Search_Criteria";

        vm.datos = [];
        vm.puestos = [];
        vm.departamentos = [];
        vm.tiposPlanilla = [];

        vm.meses = CoreSrv.getMeses();
        vm.annos = CoreSrv.getAnnos();

        vm.busqueda = {
            empleadoId: '',
            puestoId: -1,
            departamentoId: -1,
            tipoPlanillaId: -1,
            nombre: '',
            identificacion: '',
            estado: -1,
            anno: moment().year().toString(),
            mes: (moment().month() + 1).toString()
        };

        vm.title = 'GrandesContribuyentes';

        var promisePuesto = getPuesto();
        var promiseDepartamento = getDepartamento();
        var promiseTiposPlanilla = getTiposPlanilla();

        CargarPreviousSearch();

        vm.clearCriteria = function(){
            vm.busqueda = {
                empleadoId: '',
                puestoId: -1,
                departamentoId: -1,
                tipoPlanillaId: -1,
                nombre: '',
                identificacion: '',
                estado: -1,
                anno: moment().year().toString(),
                mes: (moment().month() + 1).toString()
            };
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.goToEdit = function(dato){
            
            var path = '/editar-grandes-contribuyentes/' + vm.busqueda.anno + '/' + vm.busqueda.mes + '/';

            if(dato){
                $location.path(path + dato.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.delete = function(dato){
            var promise = ArchivoCCSSService.remove(dato);
            
            promise
            .then(function(response){
                vm.datos = vm.datos.filter(function(g) {
                    return g.id !== dato.id;
                });
                logger.success('Eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar');
                        break;
                }
                
            });   
        };

        function CargarPreviousSearch(){
            var previousSearch = UserInfoService.getDataFromSessionStorage(searchKey);
            if(previousSearch){
                vm.busqueda = previousSearch;
                $q.all([promiseDepartamento, promisePuesto, promiseTiposPlanilla]).then(function(){

                    vm.getAll();
                });               
            }
        };

        vm.getAll = function(){

            if(!vm.busqueda.companiaId){
                vm.busqueda.companiaId = UserInfoService.getCompaniaId();
            }

            var promise = ArchivoCCSSService.getAll(vm.busqueda);

            promise
            .then(function(result){
                UserInfoService.saveDataOnSessionStorage(searchKey, vm.busqueda);
                vm.datos = result.data;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        vm.getArchivo = function(){

            var promise = ArchivoCCSSService.getArchivoGrandesContribuyentes(vm.busqueda.anno, vm.busqueda.mes);

            promise
            .then(function(result){
                logger.info('Archivo descargado!');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al generar el archivo.');
                        break;
                }
            });
        };

        vm.getReporte = function(){

            var promise = ReportesService.getArchivoGrandesContribuyentes(vm.busqueda.anno, vm.busqueda.mes);

            promise
            .then(function(result){
                logger.info('Reporte descargado!');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al generar el reporte.');
                        break;
                }
            });
        };

        function getPuesto(){
            var promise = PuestosService.getAll()
            .then(function(puestos){
                vm.puestos = puestos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getDepartamento(){
            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId())
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAll(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

    }
})();